/** `Audit` — in allen vier Ansichten identisch. */

import { Button } from '@/components/ui';

export interface AuditButtonProps {
  /** Ohne ausgewählten Datensatz ist die Schaltfläche gesperrt. */
  selectedId: number | null;
  onClick(): void;
}

export function AuditButton(props: AuditButtonProps) {
  return (
    <Button
      title="List Audit"
      iconClass="e-icons e-clock"
      className="button-c"
      disabled={props.selectedId === null}
      onClick={() => {
        props.onClick();
      }}
    >
      Audit
    </Button>
  );
}

export default AuditButton;
